
<tds-modal #NotificationDetailModal closable selector="#modalSelector"  header="Notification Detail" id="delete-modal" size="sm" actions-position="static">
  <span slot="body">
    <p><strong>Title:</strong> {{ currentNotification.title }}</p>

    <p class="tds-u-flex tds-u-gap2 tds-u-align-center">
      <strong>Type:</strong>
      <tds-message
        minimal
        size
        header="{{ currentNotification.messageType }}"
        [variant]="getDisplayType(currentNotification.messageType || '')"
      >
      </tds-message>
    </p>

    <div>
      <strong>Description:</strong> 
      <pre class="text-container tds-detail-01" [innerHTML]="currentNotification.message  | safeHtml"></pre>
    </div>

    <p><strong>Notification Period:</strong> {{ (currentNotification.startAt ?? '') | dayjs: 'DD/MM/YYYY' }} - {{ (currentNotification.expirationAt ?? '') | dayjs: 'DD/MM/YYYY' }}</p>
  </span>
  <span slot="actions" class="tds-u-flex tds-u-gap2">
    <tds-button data-dismiss-modal size="md" text="Confirm" (click)="afterClose()"></tds-button>
  </span>
</tds-modal>

@if(formattedEntities(); as entities){
  <div class="notification-list tds-u-flex tds-u-flex-dir-col tds-u-gap1">
    @for(entity of entities; track entity.key){
      <div [class]="showNotifyPeriod ? 'tds-u-flex tds-u-justify-between' : ''">
        <a href="javascript:void(0)" id="modalSelector"  (click)="openDetail(entity)" class="notification-link">
          <tds-message
            [variant]="getDisplayType(entity.messageType)"
            [header]="entity.title"
            tds-alert-dialog="dialog"
            tds-aria-label="A Message component"
            [minimal]="entity.minimal"
          >
            {{entity.message}}
          </tds-message>
        </a>
        @if(showNotifyPeriod) {
          <span class="notification-time">{{ entity.startAt | dayjs: 'DD/MM/YYYY' }} - {{ entity.expirationAt | dayjs: 'DD/MM/YYYY' }}</span>
        }
      </div>
    }@empty {
      @if(showEmptyMessage) {
        <div aria-hidden="true"> {{ emptyMessage }}</div>
      }
    }
  </div>
}
